var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97507 0.861938C3.92618 0.861938 0.640137 4.14799 0.640137 8.19687C0.640137 12.2457 3.92618 15.5318 7.97507 15.5318C12.0239 15.5318 15.31 12.2457 15.31 8.19687C15.31 4.14799 12.0239 0.861938 7.97507 0.861938ZM7.97507 3.79591C9.39071 3.79591 10.5423 4.94749 10.5423 6.36313C10.5423 7.77878 9.39071 8.93036 7.97507 8.93036C6.55942 8.93036 5.40784 7.77878 5.40784 6.36313C5.40784 4.94749 6.55942 3.79591 7.97507 3.79591ZM7.97507 14.0648C6.48607 14.0648 4.72569 13.4633 3.47142 11.9524C4.71102 10.9841 6.27336 10.3973 7.97507 10.3973C9.67677 10.3973 11.2391 10.9841 12.4787 11.9524C11.2244 13.4633 9.46406 14.0648 7.97507 14.0648Z",
    fill: "#25434F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileProfileIcon);
export default __webpack_public_path__ + "static/media/mobileProfileIcon.cae15cc3bfb6cce584e80d0c5739f5ae.svg";
export { ForwardRef as ReactComponent };